import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperationalDashboardRoutingModule } from './operational-dashboard-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { OperationalDashboardComponent } from './operational-dashboard.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { GetHTTPService } from './operational-dashboard.DataService';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MyDatePickerModule } from 'mydatepicker';
import { OperationalDashboardService } from './operational-dashboard.service';
import { OigExceedDataServiceService } from './oig-exceed-data-service.service';
import { GetEINService } from './operational-dashboard.EINDataService';
import { GetPgmTypeService } from './operational-dashboard.pgmtypedataservice';

@NgModule({
  declarations: [OperationalDashboardComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    GridModule,
    MyDatePickerModule,
    NgxChartsModule,
    NgxUiLoaderModule,
    OperationalDashboardRoutingModule,
    MaskedTextBoxModule

  ],
  providers: [ GetHTTPService,OperationalDashboardService,ColumnChooserService,FilterService,PageService,ResizeService,OigExceedDataServiceService, GetEINService, GetPgmTypeService ]
})
export class OperationalDashboardModule { }
